import { Component, DoCheck, OnDestroy } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@rillion/components/icon/icon.component';
import { SafePipeModule } from 'safe-pipe';
import { ResolveStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export type ToastType = 'info' | 'warning' | 'error' | 'success' | 'blocked' | 'locked';

export interface ToastConfig {
  type: ToastType;
  extraWidth: boolean;
}

@Component({
  standalone: true,
  selector: 'rl-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  imports: [CommonModule, IconComponent, SafePipeModule],
})
export class ToastComponent extends Toast<ToastConfig> implements DoCheck, OnDestroy {
  get type() {
    return this.options?.payload?.type;
  }

  get extraWidth() {
    return this.options?.payload?.extraWidth;
  }

  get icon() {
    switch (this.type) {
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      case 'success':
        return 'check_circle';
      case 'locked':
        return 'lock';
      case 'blocked':
        return 'block';
      default:
        return '';
    }
  }

  wiggle = false;

  constructor(
    private readonly router: Router,
    toastrService: ToastrService,
    toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);

    // Close toast on route change
    this.router.events
      .pipe(
        takeUntilDestroyed(),
        filter((e) => e instanceof ResolveStart),
      )
      .subscribe(() => {
        // Automatically close persistent messages on route change
        if (this.type === 'locked') {
          this.close();
        }
      });
  }

  ngDoCheck() {
    // Wiggle only once on first duplicate
    if (this.duplicatesCount === 1) {
      this.wiggle = true;
      setTimeout(() => (this.wiggle = false), 500);
    }
  }

  close(e?: Event) {
    e?.stopPropagation();

    this.toastrService.remove(this.toastPackage.toastId);
  }
}
